import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Provider from '../../../providers/common/Provider';
import CreateProductMasterDataPane from './ProductMasterData/CreateProductMasterDataPane';
import ProductMasterDataOverviewPane from './ProductMasterData/ProductMasterDataOverviewPane';
import UpdateProductMasterDataPane from './ProductMasterData/UpdateProductMasterDataPane';
import ProductMasterDataSettingsScreen from './Settings/ProductMasterDataSettingsScreen';

export default function ReferenceDataScreen() {
  return (
    <ReferenceDataScreenProvider>
      <Routes>
        <Route path='settings/*' element={<ProductMasterDataSettingsScreen />} />

        <Route path='create/*' element={<CreateProductMasterDataPane />} />
        <Route path='update/:id/*' element={<UpdateProductMasterDataPane />} />
        <Route path='*' element={<ProductMasterDataOverviewPane />} />
      </Routes>
    </ReferenceDataScreenProvider>
  );
}

function ReferenceDataScreenProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider
      bin
      binConstraint
      comment
      csvUploadConfiguration
      customField
      file
      handlingUnit
      kit
      kitTemplates
      order
      product
      productMasterData
      productMasterDataExportConfiguration
      productTransaction
      reorderRule
      reorderRuleExportConfiguration
      stockLocation
      stockLocationRoleAssignment
      tableSettings
      tag
      tagRelation
    >
      {children}
    </Provider>
  );
}
